<div *ngIf="reportType == 'OfficeRepbriefly'">

  <!-- ACTION BUTTONS -->
  <div style="margin-left:80%; margin-top:2%;" class="noPrint">

    <button mat-raised-button color="primary"
            (click)="exportExcel('Office_Rep_Outstanding_Brief_Report')">
      Export
    </button>

    <button class="btn btn-primary" (click)="printPage42()">Print</button>

    <button mat-button mat-dialog-close>Close</button>
  </div>

  <!-- PRINT SECTION -->
  <div id="print-section">

    <!-- ================= MAIN HEADER (FIRST PAGE ONLY) ================= -->
    <div class="main-header-wrapper">
      <table style="width:100%; border-collapse:collapse; margin-bottom:0;margin-right:10%;">
        <thead>

          <!-- TITLE ROW -->
          <tr>
            <td style="font-size:18px; font-weight:bold; text-align:center; padding:8px;border-left:1px solid black;border-right:1px solid black;border-top:1px solid black;">
              हिंदुस्तान प्रकाशन संस्था 
            </td>

            <td style="font-size:20px; font-weight:bold; text-align:center; padding:8px;border-top:1px solid black;border-right:1px solid black;">
              Book Outstanding Report 
            </td>

            <td style="font-size:18px; text-align:right; padding:8px; white-space:nowrap;border-top:1px solid black;border-right:1px solid black;font-weight:bold;">
              दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

          <!-- SUBTITLE ROW -->
          <tr style="border-top:1px solid black;">
            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-left:1px solid black;border-left:1px solid black;border-right:1px solid black;">
              विवेक पुस्तक प्रकाशन
            </td>

            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-right:1px solid black;">
              Office Rep Very Briefly
            </td>

            <td style="font-size:16px; text-align:right; padding:8px; white-space:nowrap;border-right:1px solid black;font-weight:bold;">
              Date : From {{ startDate | date:'dd-MM-yyyy' }}<br>
              To {{ endDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

        </thead>
      </table>
    </div>

    <!-- ================= MAIN DATA TABLE ================= -->
    <table style="width:100%; border-collapse:collapse;">

      <!-- COLUMN HEADER — REPEATS EACH PAGE -->
      <thead class="repeat-header">
        <tr style="font-weight:bold; ">

          <th style="border:1px solid black; padding:6px; font-size:16px;">
            Office Representative Name
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Invoice Amount
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Paid Amount
          </th>

          <!-- <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Credit Amount
          </th> -->

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Unpaid Amount
          </th>
        </tr>
      </thead>

      <!-- ================= BODY ================= -->
      <tbody>

        <!-- LOOP EACH OFF REP -->
        <ng-container *ngFor="let data of UnpaidOutstandingB">

          <tr>
            <td style="border:1px solid black; padding:8px; font-size:16px; ">
              {{ data.off_rep_name }}
            </td>

            <td style="border:1px solid black; padding:8px; font-size:16px; text-align:right;">
              {{ data.inv_Total }}
            </td>

            <td style="border:1px solid black; padding:8px; font-size:16px; text-align:right;">
              {{ data.paid_Total }}
            </td>

            <!-- <td style="border:1px solid black; padding:8px; font-size:16px; text-align:right;">
              {{ data.crdt_Total }}
            </td> -->

            <td style="border:1px solid black; padding:8px; font-size:16px; text-align:right;">
              {{ data.bal_Total }}
            </td>
          </tr>

        </ng-container>

        <!-- ================= GRAND TOTAL ================= -->
        <tr style="background:#c8753f; color:white; font-weight:bold; font-size:16px;">
          <td style="border:1px solid black; padding:8px;">
            Grand Total:
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ unpaidtotalInvAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ unpaidtotalPaidAmount }}
          </td>

          <!-- <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ unpaidtotalCrdtAmount }}
          </td> -->

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ unpaidtotalUnpaidAmount }}
          </td>
        </tr>

      </tbody>

    </table>

  </div>

</div>